import BaseSection from "../layout/BaseSection"
import BaseText from "../general/BaseText"
import { HashLink } from "react-router-hash-link"
import BaseHeadline from "../general/BaseHeadline"
import BasePrimaryButton from "../general/BasePrimaryButton"
import { getIndustries } from "../../api/apiCalls"
import { useQuery } from "@tanstack/react-query"
import Loading from "./Loading"
import euKofinanzierung from "../../assets/sab.avif"

export default function Footer() {
    const {data: industries, isLoading: industriesLoading} = useQuery({
        queryKey: ["industries"],
        queryFn: () => getIndustries(),
    })


    if (industriesLoading && !industries) {
        return <Loading />
    }
    return (
        <div className="w-full bg-neutral/70 flex flex-col lg:flex-row justify-center  px-4 md:px-8 lg:px-16 relative overflow-hidden">
            <div className="text-base-200/40 absolute leading-none top-0 right-1/2 translate-x-1/2 md:translate-x-0  md:-bottom-24 md:right-40 z-0 flex items-center justify-center">
                <div className="font-wicode font-extrabold text-[40rem] md:text-[14rem]">W</div>
                <div className="font-bold text-[12rem] pb-8 hidden md:block">ICODE</div>
            </div>
            {/* <div className="absolute top-0 left-32 ">
                   <motion.span 
                     animate={{ opacity: [0.15, 0.5, 0.15] }}
                     transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                   className="text-[40rem] font-bold text-center font-wicode text-outline-xthick !leading-[0.85]">
                    W
                   </motion.span>

            </div> */}
            <BaseSection paddings="py-8 sm:py-16 md:py-24 lg:py-32 z-10" flexCol width="max-w-screen-2xl">
                <div className="relative flex flex-col md:flex-row md:justify-between items-center w-full">
                    <BaseHeadline
                        headline="Digitale Lösungen. Individuell gedacht."
                        width="max-w-xl"
                        headlineClassProps="!leading-tight text-center md:text-left"
                    />
                    <div className="flex gap-8 items-center pt-8 flex-col md:flex-row md:flex-wrap pb-4 lg:pb-2 justify-end">
                        <HashLink to="/#_" className="text-sm uppercase font-semibold hover:underline">
                            Homepage
                        </HashLink>
                        <HashLink to="/portfolio#_" className="text-sm uppercase font-semibold hover:underline">
                            Portfolio
                        </HashLink>
                        <HashLink to="/about#_" className="text-sm uppercase font-semibold hover:underline">
                            Über uns
                        </HashLink>
                        <BasePrimaryButton text={"Kontakt aufnehmen"} url={"/contact#_"} classProps="w-full md:w-fit justify-center" />
                    </div>
                </div>
                <div className="border-t-2 border-base-300 flex flex-col md:flex-row w-full items-center justify-between gap-5 md:gap-6 pt-6 z-10">
                    <div className="order-2 md:order-1 text-xs font-text flex flex-wrap gap-4 font-semibold text-gray-300 justify-center md:justify-start">
                        <HashLink className="cursor-pointer hover:underline" to="/impressum#_">
                            Impressum
                        </HashLink>
                        <HashLink className="cursor-pointer hover:underline" to="/datenschutz#_">
                            Datenschutz
                        </HashLink>
                        <HashLink className="cursor-pointer hover:underline" to="/agb#_">
                            AGB
                        </HashLink>
                    </div>
                    <div
                        className="order-1 md:order-2 w-full md:w-auto flex justify-center shrink-0 rounded-lg bg-white px-5 py-3 md:px-6 md:py-4 shadow-sm ring-1 ring-base-300/40"
                        title="Gefördert durch die Europäische Union und die Sächsische Aufbaubank"
                    >
                        <img
                            src={euKofinanzierung}
                            alt="Gefördert durch die Europäische Union und die Sächsische Aufbaubank"
                            className="h-20 md:h-24 lg:h-28 w-auto max-w-[min(100%,24rem)] md:max-w-[22rem] lg:max-w-[28rem] object-contain"
                            loading="lazy"
                        />
                    </div>
                    <BaseText textSize="text-xs" text={"© 2025 Wicode GmbH"} classProps="!text-gray-300 order-3 shrink-0" />
                </div>
            </BaseSection>
        </div>
    )
}
